/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/directives/shared/dropdown.directive';
import * as i4 from '../../../../app/components/anon/header.component';
import * as i5 from '../../../../$$_gendir/node_modules/@progress/kendo-angular-inputs/dist/es/switch/switch.component.ngfactory';
import * as i6 from '@progress/kendo-angular-l10n';
import * as i7 from '@progress/kendo-angular-inputs/dist/es/switch/switch.component';
import * as i8 from '@angular/forms';
import * as i9 from '../../../../app/services/auth/auth.service';
import * as i10 from '@angular/http';
import * as i11 from '../../../../app/pipes/title-case.pipe';
const styles_HeaderComponent:any[] = ([] as any[]);
export const RenderType_HeaderComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_HeaderComponent,data:{}});
function View_HeaderComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'li',[['routerLinkActive',
      'active']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(1720320,(null as any),2,i1.RouterLinkActive,[i1.Router,i0.ElementRef,
          i0.Renderer2,i0.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i0.ɵqud(603979776,2,{links:1}),i0.ɵqud(603979776,3,{linksWithHrefs:1}),
      (_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),2,'a',[['routerLink','/search']],[[1,'target',0],[8,'href',
              4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,6).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(671744,[[3,4]],0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['Search'])),(_l()(),i0.ɵted((null as any),
          ['\n        ']))],(_ck,_v) => {
    const currVal_0:any = 'active';
    _ck(_v,1,0,currVal_0);
    const currVal_3:any = '/search';
    _ck(_v,6,0,currVal_3);
  },(_ck,_v) => {
    const currVal_1:any = i0.ɵnov(_v,6).target;
    const currVal_2:any = i0.ɵnov(_v,6).href;
    _ck(_v,5,0,currVal_1,currVal_2);
  });
}
function View_HeaderComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'li',[['routerLinkActive',
      'active']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(1720320,(null as any),2,i1.RouterLinkActive,[i1.Router,i0.ElementRef,
          i0.Renderer2,i0.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i0.ɵqud(603979776,4,{links:1}),i0.ɵqud(603979776,5,{linksWithHrefs:1}),
      (_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),2,'a',[['routerLink','/login']],[[1,'target',0],[8,'href',
              4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,6).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(671744,[[5,4]],0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['Log In'])),(_l()(),i0.ɵted((null as any),
          ['\n        ']))],(_ck,_v) => {
    const currVal_0:any = 'active';
    _ck(_v,1,0,currVal_0);
    const currVal_3:any = '/login';
    _ck(_v,6,0,currVal_3);
  },(_ck,_v) => {
    const currVal_1:any = i0.ɵnov(_v,6).target;
    const currVal_2:any = i0.ɵnov(_v,6).href;
    _ck(_v,5,0,currVal_1,currVal_2);
  });
}
function View_HeaderComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),25,'li',[['appDropdown',
      ''],['class','dropdown']],[[2,'open',(null as any)]],[[(null as any),'click'],
      [(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1).toggleOpen()) !== false);
      ad = (pd_0 && ad);
    }
    if (('mouseenter' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).onMouseenter()) !== false);
      ad = (pd_1 && ad);
    }
    if (('mouseleave' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,1).onMouseLeave()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i3.DropdownDirective,
      ([] as any[]),(null as any),(null as any)),(_l()(),i0.ɵted((null as any),['\n          \n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),2,'a',[['class','dropdown-toggle'],
          ['data-toggle','dropdown'],['role','button'],['style','cursor:pointer']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['Manage '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'span',[['class','caret']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),17,'ul',[['class','dropdown-menu']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          2,'a',[['routerLink','/terms-of-service'],['style','cursor:pointer']],[[1,
              'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,11).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(671744,(null as any),0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['Terms Of Service'])),(_l()(),
          i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'li',[['class','divider']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),2,'a',[['routerLink','/change-password'],['style',
              'cursor:pointer']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,18).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(671744,(null as any),0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['Change Password'])),(_l()(),
          i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),2,'li',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'a',[['style','cursor:pointer']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onLogout()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['Log Out'])),
      (_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),i0.ɵted((null as any),
          ['\n        ']))],(_ck,_v) => {
    const currVal_3:any = '/terms-of-service';
    _ck(_v,11,0,currVal_3);
    const currVal_6:any = '/change-password';
    _ck(_v,18,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).isOpen;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i0.ɵnov(_v,11).target;
    const currVal_2:any = i0.ɵnov(_v,11).href;
    _ck(_v,10,0,currVal_1,currVal_2);
    const currVal_4:any = i0.ɵnov(_v,18).target;
    const currVal_5:any = i0.ɵnov(_v,18).href;
    _ck(_v,17,0,currVal_4,currVal_5);
  });
}
export function View_HeaderComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{navbar:0}),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),11,'div',[['class','row']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),7,'div',[['class','col-xs-2']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'a',[['routerLink',
      '/']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,6).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(671744,(null as any),0,i1.RouterLinkWithHref,
      [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),0,'img',[['alt','YuDrivPortal'],['class','logo'],
          ['src','assets/images/logo.png']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
      i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),
      i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵted((null as any),['\n\n'])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),61,'nav',[['class','navbar navbar-default']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          58,'div',[['class','container-fluid']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),19,'div',[['class','navbar-header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),10,'button',[['aria-expanded','false'],['class','navbar-toggle collapsed'],
              ['data-toggle','collapse'],['type','button']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.HeaderComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.togleMenu()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['Toggle navigation'])),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'span',
          [['class','icon-bar']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),0,'span',[['class','icon-bar']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'span',
          [['class','icon-bar']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),
          ['\n      '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'a',[['class',
          'navbar-brand'],['routerLink','/']],[[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,33).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(671744,(null as any),0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['',' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'span',[['style','font-size:12px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['',''])),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),
          ['\n\n    '])),(_l()(),i0.ɵeld(0,[[1,0],['navbar',1]],(null as any),34,'div',
          [['class','collapse navbar-collapse']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),17,'ul',[['class','nav navbar-nav']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_HeaderComponent_1)),i0.ɵdid(16384,(null as any),0,i2.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          10,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),7,'kendo-switch',([] as any[]),[[1,
              'dir',0],[1,'aria-disabled',0],[1,'aria-checked',0],[2,'k-widget',(null as any)],
              [2,'k-switch',(null as any)],[2,'k-switch-on',(null as any)],[2,'k-switch-off',
                  (null as any)],[2,'k-state-disabled',(null as any)],[2,'k-state-focused',
                  (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
                  (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.HeaderComponent = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,52).keyDown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_1:any = ((<any>(_co.dayNight = $event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>_co.onDayNightChange($event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i5.View_SwitchComponent_0,i5.RenderType_SwitchComponent)),i0.ɵprd(256,
          (null as any),i6.L10N_PREFIX,'kendo.switch',([] as any[])),i0.ɵprd(131584,
          (null as any),i6.LocalizationService,i6.LocalizationService,[i6.L10N_PREFIX,
              [2,i6.MessageService],[2,i6.RTL]]),i0.ɵdid(4243456,(null as any),0,i7.SwitchComponent,
          [[2,i6.RTL],i6.LocalizationService],(null as any),(null as any)),i0.ɵprd(1024,
          (null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i7.SwitchComponent]),i0.ɵdid(671744,(null as any),0,i8.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i8.NgControl,
          (null as any),[i8.NgModel]),i0.ɵdid(16384,(null as any),0,i8.NgControlStatus,
          [i8.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),
          ['\n\n      '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'ul',[['class',
          'nav navbar-nav navbar-right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),(null as any),
              [[(null as any),'click']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i4.HeaderComponent = _v.component;
                if (('click' === en)) {
                  const pd_0:any = ((<any>_co.togleMenu()) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },(null as any),(null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          2,'a',[['routerLink','/']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,67).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(671744,(null as any),0,i1.RouterLinkWithHref,
          [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_HeaderComponent_3)),i0.ɵdid(16384,(null as any),0,i2.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵted((null as any),['\n'])),
      (_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i4.HeaderComponent = _v.component;
    const currVal_2:any = '/';
    _ck(_v,6,0,currVal_2);
    const currVal_5:any = '/';
    _ck(_v,33,0,currVal_5);
    const currVal_8:any = _co.showVehicle;
    _ck(_v,45,0,currVal_8);
    const currVal_25:any = _co.dayNight;
    _ck(_v,54,0,currVal_25);
    const currVal_26:boolean = !_co.loggedIn;
    _ck(_v,63,0,currVal_26);
    const currVal_29:any = '/';
    _ck(_v,67,0,currVal_29);
    const currVal_31:any = _co.loggedIn;
    _ck(_v,71,0,currVal_31);
  },(_ck,_v) => {
    var _co:i4.HeaderComponent = _v.component;
    const currVal_0:any = i0.ɵnov(_v,6).target;
    const currVal_1:any = i0.ɵnov(_v,6).href;
    _ck(_v,5,0,currVal_0,currVal_1);
    const currVal_3:any = i0.ɵnov(_v,33).target;
    const currVal_4:any = i0.ɵnov(_v,33).href;
    _ck(_v,32,0,currVal_3,currVal_4);
    const currVal_6:any = _co.appName;
    _ck(_v,34,0,currVal_6);
    const currVal_7:any = _co.dbVersion;
    _ck(_v,36,0,currVal_7);
    const currVal_9:any = i0.ɵnov(_v,52).direction;
    const currVal_10:any = i0.ɵnov(_v,52).ariaDisabled;
    const currVal_11:any = i0.ɵnov(_v,52).ariaChecked;
    const currVal_12:any = i0.ɵnov(_v,52).hostClasses;
    const currVal_13:any = i0.ɵnov(_v,52).hostClasses;
    const currVal_14:any = i0.ɵnov(_v,52).switchOnClass;
    const currVal_15:any = i0.ɵnov(_v,52).switchOffClass;
    const currVal_16:any = i0.ɵnov(_v,52).disabledClass;
    const currVal_17:any = i0.ɵnov(_v,52).focusedClass;
    const currVal_18:any = i0.ɵnov(_v,56).ngClassUntouched;
    const currVal_19:any = i0.ɵnov(_v,56).ngClassTouched;
    const currVal_20:any = i0.ɵnov(_v,56).ngClassPristine;
    const currVal_21:any = i0.ɵnov(_v,56).ngClassDirty;
    const currVal_22:any = i0.ɵnov(_v,56).ngClassValid;
    const currVal_23:any = i0.ɵnov(_v,56).ngClassInvalid;
    const currVal_24:any = i0.ɵnov(_v,56).ngClassPending;
    _ck(_v,49,1,[currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,
        currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,
        currVal_22,currVal_23,currVal_24]);
    const currVal_27:any = i0.ɵnov(_v,67).target;
    const currVal_28:any = i0.ɵnov(_v,67).href;
    _ck(_v,66,0,currVal_27,currVal_28);
    const currVal_30:any = _co.welcomeMessage;
    _ck(_v,68,0,currVal_30);
  });
}
export function View_HeaderComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),
      (null as any),(null as any),(null as any),View_HeaderComponent_0,RenderType_HeaderComponent)),
      i0.ɵdid(245760,(null as any),0,i4.HeaderComponent,[i9.AuthService,i0.Renderer,
          i10.Http,i11.TitleCasePipe],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HeaderComponentNgFactory:i0.ComponentFactory<i4.HeaderComponent> = i0.ɵccf('app-header',
    i4.HeaderComponent,View_HeaderComponent_Host_0,{},{opacityChanged:'opacityChanged'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/app/components/anon/header.component.ngfactory.ts